"use client";

import { useHits } from "react-instantsearch";
import { AlgoliaPost } from "@repo/algolia/types";
import PostsMosaic from "../PostsMosaic/PostsMosaic";

type Props = {
  dark?: boolean;
};

const InternalAlgoliaPostsMosaic: React.FC<Props> = ({ dark = false }) => {
  const { items, results } = useHits<AlgoliaPost>();
  const pageNumber = results?.page ?? 0;

  return (
    <PostsMosaic
      posts={items}
      variant={pageNumber === 0 ? "4-columns+2-columns-wide" : "2-columns-wide"}
      darkMode={dark}
    />
  );
};

export default InternalAlgoliaPostsMosaic;
